import { useSyncExternalStore } from "react";
import { freshnessClock } from "@/lib/analytics/freshnessClock";

/**
 * The time a freshness chip is judged against, re-rendering the caller on every tick of the page's
 * one shared clock; the caller's subscription ends on unmount (ANL-E04-S09).
 */
export const useFreshnessNow = (): number =>
  useSyncExternalStore(freshnessClock.subscribe, freshnessClock.now, freshnessClock.now);
